import { render, staticRenderFns } from "./AllResource.vue?vue&type=template&id=47e423ee"
import script from "./AllResource.vue?vue&type=script&lang=js"
export * from "./AllResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports